import { Validator } from "../../../shared/services/validator";
import { CTRL_NAME_EXTRACTOR } from "../ctrl.name.extractor";
 
export class CTRL_1112 implements Validator { 
 
    public static id = 'CTRL_1112'; 
    private message = 'error.ctr_1112'; //message d’erreur en dur, à terme dans un JSON FR ou EN 
 
 
 
 
    validate(form: any, map) { 
 
 
        // vérifier si la règle est applicable sur mon formulaire 
        const rgs: string[] = CTRL_NAME_EXTRACTOR.getCtrlNames(form, CTRL_1112.id); 
 
 
        if (rgs.length > 0) { 
            for (var rg of rgs) { 
                const ctrl = form.controls[rg]; 
			//ajout du STEP_ID sur le champ 
                const inputNameWithStepId1 = map.get(ctrl.value.rgCtrls.obj_1112_1); 
                const inputCtrl1 = form.controls[inputNameWithStepId1]; 
                const inputNameWithStepId2 = map.get(ctrl.value.rgCtrls.obj_1112_2); 
                const inputCtrl2 = form.controls[inputNameWithStepId2]; 
                if (!this.isNull(inputCtrl1) && !this.isNull(inputCtrl2)) { 
                    // placer le message d'erreur 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: true, validation_message: this.message }; 
                } else { 
                    form.controls[rg].value = { rgCtrls: ctrl.value.rgCtrls, ctrlValidation: false }; 
                } 
            } 
        } 
    } 

    isNull(value): boolean{
        return (value == undefined || value == null || value == '');
    }
} 
 
